package it.unibo.tuprolog

object Info {
    const val VERSION = "3.0.7-dev02-1ff1acfa1"
    val PLATFORM: Platform by lazy { currentPlatform() }
    val OS: Os by lazy { currentOs() }
}
